import React, { useEffect, useState } from "react";
import DataTable from "../../common/dataTable";
import { Grid, Radio } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import dayjs from "dayjs";
import { itemsPerPage } from "../../utils/constants";
import TablePagination from "../../common/tablePagination";
import capRegistrationActions from "../../redux/capRegistration/actions";

export default function CapCourseDocumentTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { backofficeTokenDetails } = useSelector(state => state.authReducer);

  const { capDocuments } = useSelector(state => state.capReducer);
  console.log("capCoursecapCourse",capDocuments);
  
  const [tableData, setTableData] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  
  useEffect(() => {
    createTabledata()
  }, [capDocuments]);

  
  const handleActive = (active, type, documenttypeid) => {
    if (type !== active) {
      let data = {
        userid: backofficeTokenDetails?.id,
        documenttypeid: documenttypeid,
        isactive: type
      }
      dispatch({
        type: capRegistrationActions.SET_ACTIVE_CAP_COURSE_DOC,
        payload: { data: data },
      });
    }
  }

  const createTabledata = () => {
    if (!capDocuments || !Array.isArray(capDocuments)) return;
  
    let data = capDocuments.map((obj, index) => ({
      id: index + 1, 
      documenttypeid:obj.documenttypeid,
      documenttype: obj.documenttype || "N/A",
      enable: (
        <Radio
          checked={obj.isactive === "1"}
          onClick={() => handleActive(obj.isactive, "1", obj.documenttypeid)}
        />
      ),
      disable: (
        <Radio
          checked={obj.isactive === "0"}
          onClick={() => handleActive(obj.isactive, "0", obj.documenttypeid)}
        />
      ),
    }));
  
    setTableData(data);
  };
  



  useEffect(() => {
    dispatch({ type: capRegistrationActions.GET_CAP_COURSE_DOCUMENT })
  }, [])
  const tableKeys = [
    {
      name: "S.No",
      accessor: "id",
      sortOption: false,
    },
    {
      name: "Cap Document Name",
      accessor: "documenttype",
      sortOption: false,
    },
    {
      name: "Enable",
      accessor: "enable",
      sortOption: false,

    },
    {
      name: "Disable",
      accessor: "disable",
      sortOption: false,
    },
  ];

 

  const handleCapCourseDocumentUpdate = (val) => {
    navigate(`/${Cookies.get("mhet_mst_project")}/cap-course-document-master?page=updatecapcoursedocument`, { state: { id: val } });
  }

 

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = tableData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(tableData?.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(value);
  };

  return (
    <Grid>
      <DataTable
        keys={tableKeys}
        values={currentItems}
        page={"document-list"}
        handleCapCourseDocumentUpdate={handleCapCourseDocumentUpdate}
      />
      <TablePagination
        pageCount={pageCount}
        handlePageChange={handlePageChange}
        currentPage={currentPage}
      />
    </Grid>
  );
}
